import { render, staticRenderFns } from "./updateRecordModal.vue?vue&type=template&id=f4639e80&scoped=true"
import script from "./updateRecordModal.vue?vue&type=script&lang=js"
export * from "./updateRecordModal.vue?vue&type=script&lang=js"
import style0 from "./updateRecordModal.vue?vue&type=style&index=0&id=f4639e80&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4639e80",
  null
  
)

export default component.exports